import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const Content = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
});
